<template>
<div class="modal">
  <div class="modal-background" @click="dismiss"></div>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">What's New</p>
      <button class="delete" aria-label="close" @click="dismiss"></button>
    </header>
    <section class="modal-card-body">
      <h1 class="title">SDV 1.5 Update</h1>
      <div class="content">
        <p>Hey All!</p>

        <p>
          If you're here, you problably know that Stardew Valley just released version 1.5, which includes
          a staggering amount of new content, including the ability to remix bundles. We're working on
          adding the new content, but there's a lot and we don't know quite all the details involved in how
          the systems all work yet.

          We do have some new features available that I've detailed below.
        </p>
        <p>
          Thanks, <br />
          Kihashi
        </p>
        <h3 class="title">New Features</h3>
        <ul>
          <li>Compact View</li>
          <ul>
            <li>Shows a table instead of cards</li>
            <li>Enable it under the Settings</li>
            <li>Note that this view may not work as well on mobile displays</li>
          </ul>
          <li>Show skill and season name when hovering over the icon</li>
          <li>Fix a bug where the search page would space cards out too far on desktop</li>
          <li>Align checkboxes in item cards</li>
        </ul>
      </div>
    </section>
    <footer class="modal-card-foot">
      <a href="https://www.reddit.com/r/stardewchecklist/" class="button is-info">Subreddit</a>
      <a href="https://github.com/kihashi/stardew_community_checklist" class="button">Github</a>
    </footer>
  </div>
</div>
</template>

<script>
export default {
  name: 'whats-new',
  methods: {
    dismiss: function () {
      this.$emit('dismiss-modal')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/New.vue